
import { TransferAssetApproverEntityDecorator } from './transfer-asset-approver.decorator';
import { TransferAssetApprover } from './transfer-asset-approver.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class TransferAssetApproverTypeInfoBase implements CrudTypeInfo<TransferAssetApprover, string> {
  name = 'Transfer Asset Approver';
  entityDecorator = new TransferAssetApproverEntityDecorator();
  
  createAuthorities = ['WRITE_TRANSFER_ASSET_APPROVER'];
  editAuthorities = ['WRITE_TRANSFER_ASSET_APPROVER'];
  deleteAuthorities = ['WRITE_TRANSFER_ASSET_APPROVER'];
  viewAuthorities = ['READ_TRANSFER_ASSET_APPROVER'];
  
  searchRouteBase = ['/transferassetapprover/search'];
  createRouteBase = ['/transferassetapprover/create'];
  editRouteBase = ['/transferassetapprover/edit'];
  viewRouteBase = ['/transferassetapprover/view'];
  
  description(item: TransferAssetApprover): string {
    return '' +  item.approverId;
  }
}



